<script>
import fields from '@/components/fields/'
import BaseWidgetForm from "./BaseWidgetForm";

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        ...this.getCommonFields(),
        {
          label: 'Ogólne',
          fields: [
            new fields.Link({
              labelPlaceholder: 'Tekst buttona',
              label: 'Button',
              required: true,
              modelPath: [this, 'form', 'button']
            }),
            new fields.Switch({
              labelPlaceholder: 'Ciemne tło',
              label: 'Ciemne tło',
              required: true,
              modelPath: [this, 'form', 'dark_background'],
              type: 'checkbox'
            }),
          ]
        }
      ]
    }
  }
}
</script>
